export default function Impressum() {
  return (
    <main id="main-content" className="pt-32 pb-20" data-testid="impressum-page">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-[#1A52D8] mb-8">
            Impressum
          </h1>

          <div className="prose prose-lg max-w-none text-[#475569]">
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <p className="mb-4">
                <strong className="text-[#1A52D8]">Leistungserbringer und Vertragspartner:</strong>
              </p>
              <p>
                Phönix Pflegeteam Itzehoe<br />
                Lindenbusch 13a<br />
                25578 Dägeling
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">Kontakt</h2>
              <p>
                Telefon: 0151 46173685<br />
                E-Mail: info@pflegeteam-itzehoe.de
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                Kommanditistin (Webseitenbetrieb)
              </h2>
              <p>
                Lisa Fayazi<br />
                Lindenbusch 13a<br />
                Dägeling
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                Hinweis zur Kooperation
              </h2>
              <p>
                Diese Website ist eine regionale Partner- und Informationsseite von 
                Kommanditisten in Kooperation mit der zugelassenen Phönix Pflegeteam Itzehoe.
              </p>
              <p className="mt-4">
                Die pflegerischen Leistungen werden ausschließlich durch die 
                Phönix Pflegeteam Itzehoe erbracht.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p>
                Phönix Pflegeteam Itzehoe<br />
                Lindenbusch 13a<br />
                25578 Dägeling
              </p>
            </section>

            <section className="legal-notice mt-8">
              <p>
                <strong>Leistungserbringer und Vertragspartner ist die Phönix Pflegeteam Itzehoe, Dägeling.</strong>
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}
